import { buildValueMap } from "./utils";

export const BomStatusDef = {
    Active: { value: 1, label: "Active" },
    Inactive: { value: 2, label: "Inactive" }
};

export const WorkOrderStatusDef = {
    Created: { value: 1, label: "Created" },
    Issued: { value: 2, label: "Issued" },
    Picked: { value: 3, label: "Picked" },
    PartialPicked: { value: 4, label: "Partial Picked" },
    PartialPickedFulfilled: { value: 5, label: "Partial Picked Fulfilled" },
    PartialFulfilled: { value: 6, label: "Partial Fulfilled" },
    Fulfilled: { value: 7, label: "Fulfilled" },
    ShortClosed: { value: 8, label: "Short Closed" },
    Voided: { value: 9, label: "Voided" }
};

export const WOPOStatusDef = {
    Issued: { value: 1, label: "Issued" },
    Partial: { value: 2, label: "Partial" },
    Fulfilled: { value: 3, label: "Fulfilled" },
    Voided: { value: 4, label: "Voided" }
};

export const WOFulfillmentStatusDef = {
    Fulfilled: { value: 1, label: "Fulfilled" },
    Voided: { value: 2, label: "Voided" }
};

export const BomStatus = buildValueMap(BomStatusDef);
export const WorkOrderStatus = buildValueMap(WorkOrderStatusDef);
export const WOPOStatus = buildValueMap(WOPOStatusDef);
export const WOFulfillmentStatus = buildValueMap(WOFulfillmentStatusDef);
